import _JSXStyle from "styled-jsx/style";
import React, { useEffect, useRef } from 'react';
import withDefaults from '../utils/with-defaults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  visible: false,
  x: 0,
  y: 0
};

const Drip = ({
  visible,
  x,
  y,
  color,
  onCompleted,
  ...props
}) => {
  const dripRef = useRef(null);
  const top = Number.isNaN(+y) ? 0 : y - 10;
  const left = Number.isNaN(+x) ? 0 : x - 10;
  useEffect(() => {
    if (!dripRef.current) return;
    dripRef.current.addEventListener('animationend', onCompleted);
    return () => {
      if (!dripRef.current) return;
      dripRef.current.removeEventListener('animationend', onCompleted);
    };
  });
  if (!visible) return null;
  return /*#__PURE__*/_jsxs("div", {
    ref: dripRef,
    ...props,
    className: "jsx-1771680452" + " " + (props && props.className != null && props.className || "drip"),
    children: [/*#__PURE__*/_jsx("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      style: {
        top,
        left
      },
      className: "jsx-1771680452",
      children: /*#__PURE__*/_jsx("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        className: "jsx-1771680452",
        children: /*#__PURE__*/_jsx("g", {
          fill: color,
          className: "jsx-1771680452",
          children: /*#__PURE__*/_jsx("rect", {
            width: "100%",
            height: "100%",
            rx: "10",
            className: "jsx-1771680452"
          })
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1771680452",
      children: ".drip.jsx-1771680452{position:absolute;left:0;right:0;top:0;bottom:0;}svg.jsx-1771680452{position:absolute;-webkit-animation:350ms linear expand-jsx-1771680452;animation:350ms linear expand-jsx-1771680452;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;width:1rem;height:1rem;}@-webkit-keyframes expand-jsx-1771680452{0%{opacity:0;-webkit-transform:scale(0.25);-ms-transform:scale(0.25);transform:scale(0.25);}30%{opacity:1;}80%{opacity:0.5;}100%{-webkit-transform:scale(28);-ms-transform:scale(28);transform:scale(28);opacity:0;}}@keyframes expand-jsx-1771680452{0%{opacity:0;-webkit-transform:scale(0.25);-ms-transform:scale(0.25);transform:scale(0.25);}30%{opacity:1;}80%{opacity:0.5;}100%{-webkit-transform:scale(28);-ms-transform:scale(28);transform:scale(28);opacity:0;}}"
    })]
  });
};

const MemoDrip = /*#__PURE__*/React.memo(Drip);
export default withDefaults(MemoDrip, defaultProps);